$mol_string_button $mol_string
